(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-carrito"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__bsc) return;
    root.__bsc = true;
    // Sacar el carrito del footer y ponerlo directo en <body> para que siempre se vea encima de todo
    var sid = root.getAttribute('data-section-id');
    document.querySelectorAll('body > .bsc').forEach(function (old) { if (old !== root && old.getAttribute('data-section-id') === sid) old.remove(); });
    if (root.parentElement !== document.body) document.body.appendChild(root);
    var cfg = JSON.parse(root.querySelector('[data-bsc-config]').textContent);
    var base = root.getAttribute('data-root') || '/';
    var q = function (sel) { return root.querySelector(sel); };
    var panel = q('.bsc__panel'), overlay = q('.bsc__overlay');
    var nativeFetch = window.fetch.bind(window);
    var lastFocus = null, cart = null;

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function fmt(cents) {
      var f = cfg.moneyFormat;
      var n = (cents || 0) / 100;
      function group(num, dec, th, ds) { var p = num.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); }
      if (!f) return '$' + group(n, 2, ',', '.');
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
        if (k === 'amount_with_comma_separator') return group(n, 2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
        return group(n, 2, ',', '.');
      });
    }
    function fill(tpl, monto) { return esc(tpl || '').replace('[p1]', cfg.tier1Pct).replace('[p2]', cfg.tier2Pct).replace('[monto]', '<strong>' + fmt(monto) + '</strong>'); }
    function api(path, body) {
      return nativeFetch(base + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    }
    function busy(on) { root.classList.toggle('is-busy', on); }
    function showError(msg) { var e = q('[data-bsc-error]'); e.textContent = msg || ''; e.hidden = !msg; }

    function renderProgress(c) {
      var sub = c.items_subtotal_price, t1 = cfg.tier1Min * 100, t2 = cfg.tier2Min * 100, msg;
      if (!c.item_count) msg = fill(cfg.msgEmpty);
      else if (sub < t1) msg = fill(cfg.msgTier1, t1 - sub);
      else if (sub < t2) msg = fill(cfg.msgTier2, t2 - sub);
      else msg = fill(cfg.msgTier3);
      q('[data-bsc-msg]').innerHTML = msg;
      q('[data-bsc-fill]').style.width = (c.item_count ? Math.max(8, Math.min(100, (sub / t2) * 100)) : 0) + '%';
      var steps = [
        { label: 'Envío gratis', done: c.item_count > 0 },
        { label: cfg.tier1Pct + '% OFF', done: sub >= t1 },
        { label: cfg.tier2Pct + '% OFF', done: sub >= t2 }
      ];
      q('[data-bsc-steps]').innerHTML = steps.map(function (s) {
        return '<li class="' + (s.done ? 'is-done' : '') + '">' + (s.done ? '✓ ' : '') + esc(s.label) + '</li>';
      }).join('');
    }

    function renderItems(c) {
      var list = q('[data-bsc-items]');
      q('[data-bsc-empty]').hidden = c.item_count > 0;
      q('[data-bsc-foot]').hidden = c.item_count === 0;
      list.innerHTML = c.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" loading="lazy" width="84" height="84">' : '<span class="bsc__img-ph"></span>';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="bsc__item-variant">' + esc(it.variant_title) + '</span>' : '';
        var price = it.original_line_price > it.final_line_price
          ? '<s>' + fmt(it.original_line_price) + '</s><span class="is-sale">' + fmt(it.final_line_price) + '</span>'
          : '<span>' + fmt(it.final_line_price) + '</span>';
        return '<li class="bsc__item" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
          '<a href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="bsc__item-info"><a class="bsc__item-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="bsc__qty"><button type="button" data-bsc-dec aria-label="Quitar uno">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-bsc-inc aria-label="Agregar uno">+</button></div></div>' +
          '<div class="bsc__item-side"><button type="button" class="bsc__remove" data-bsc-remove aria-label="Eliminar ' + esc(it.product_title) + '">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3"/></svg></button>' +
          '<div class="bsc__price">' + price + '</div></div></li>';
      }).join('');
    }

    function renderUpsells(c) {
      var wrap = q('[data-bsc-upsell]');
      if (!wrap) return;
      var inCart = c.items.map(function (i) { return i.product_id; });
      var list = (cfg.upsells || []).filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; });
      wrap.hidden = !list.length || !c.item_count;
      q('[data-bsc-track]').innerHTML = list.map(function (p) {
        var img = p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="72" height="72">' : '<span class="bsc__img-ph"></span>';
        var price = p.compare > p.price ? '<s>' + fmt(p.compare) + '</s><span class="is-sale">' + fmt(p.price) + '</span>' : '<span>' + fmt(p.price) + '</span>';
        var btn = p.multi
          ? '<a class="bsc__card-btn" href="' + esc(p.url) + '">' + esc(cfg.btnOptions) + '</a>'
          : '<button type="button" class="bsc__card-btn" data-bsc-add="' + p.variant + '">' + esc(cfg.btnAdd) + '</button>';
        return '<li class="bsc__card"><a href="' + esc(p.url) + '">' + img + '</a><div class="bsc__card-info"><a class="bsc__card-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="bsc__price" style="text-align:left">' + price + '</div></div>' + btn + '</li>';
      }).join('');
    }

    function renderSummary(c) {
      var disc = c.original_total_price - c.total_price;
      q('[data-bsc-subtotal]').textContent = fmt(c.original_total_price);
      q('[data-bsc-disc-row]').hidden = disc <= 0;
      q('[data-bsc-disc]').textContent = '−' + fmt(disc);
      q('[data-bsc-ship]').textContent = cfg.shipFree;
      q('[data-bsc-total]').textContent = fmt(c.total_price);
      var codes = (c.discount_codes || []).filter(function (d) { return d.applicable; });
      q('[data-bsc-codes]').innerHTML = codes.map(function (d) {
        return '<li>' + esc(d.code) + ' <button type="button" data-bsc-uncode aria-label="Quitar código ' + esc(d.code) + '">✕</button></li>';
      }).join('');
    }

    function updateBubbles(c) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count], .cart-count, .cart-bubble__text, .header__cart-count').forEach(function (el) {
        if (!root.contains(el)) el.textContent = c.item_count;
      });
      document.dispatchEvent(new CustomEvent('bsc:cart-updated', { detail: c }));
    }

    function render(c) { cart = c; renderProgress(c); renderItems(c); renderUpsells(c); renderSummary(c); updateBubbles(c); }
    function refresh() { return api('cart.js').then(render); }

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      refresh().finally(function () { panel.focus(); });
    }
    function close() {
      root.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () { overlay.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function change(key, qty) {
      busy(true); showError('');
      api('cart/change.js', { id: key, quantity: qty }).then(render)
        .catch(function (e) { showError(e.description || e.message); refresh(); })
        .finally(function () { busy(false); });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bsc-close]')) { e.preventDefault(); close(); return; }
      var item = t.closest('.bsc__item');
      if (item) {
        var key = item.getAttribute('data-key'), qty = +item.getAttribute('data-qty');
        if (t.closest('[data-bsc-inc]')) change(key, qty + 1);
        else if (t.closest('[data-bsc-dec]')) change(key, Math.max(0, qty - 1));
        else if (t.closest('[data-bsc-remove]')) change(key, 0);
      }
      var add = t.closest('[data-bsc-add]');
      if (add) {
        busy(true);
        api('cart/add.js', { items: [{ id: +add.getAttribute('data-bsc-add'), quantity: 1 }] })
          .then(refresh).catch(function (er) { showError(er.description || er.message); })
          .finally(function () { busy(false); });
      }
      if (t.closest('[data-bsc-uncode]')) {
        busy(true);
        api('cart/update.js', { discount: '' }).then(render).finally(function () { busy(false); });
      }
      var track = q('[data-bsc-track]');
      if (track && t.closest('[data-bsc-next]')) track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' });
      if (track && t.closest('[data-bsc-prev]')) track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' });
    });

    q('[data-bsc-code-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = this.querySelector('input'), code = input.value.trim();
      if (!code) return;
      var existing = (cart && cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      busy(true); showError('');
      api('cart/update.js', { discount: existing.concat(code).join(',') }).then(function (c) {
        var ok = (c.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
        if (!ok) showError(cfg.codeInvalid);
        else input.value = '';
        render(c);
      }).catch(function (er) { showError(er.description || cfg.codeInvalid); })
        .finally(function () { busy(false); });
    });

    root.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('a[href], button:not([disabled]), input');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    // Abrir con el ícono del carrito del tema
    var cartSel = (cfg.cartSelectors ? cfg.cartSelectors + ', ' : '') + "[data-testid='cart-drawer-trigger'], .action__cart";
    if (cartSel) {
      document.addEventListener('click', function (e) {
        var el = e.target.closest && e.target.closest(cartSel);
        if (!el || root.contains(el)) return;
        e.preventDefault(); e.stopImmediatePropagation(); open();
      }, true);
    }

    // Abrir al agregar al carrito
    if (cfg.interceptAdd) {
      // Solo abre nuestro carrito despues de que el tema agrega (sin agregar dos veces)
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = nativeFetch.apply(window, arguments);
        if (/\/cart\/add/.test(url)) p.then(function (r) { if (r.ok) setTimeout(open, 60); });
        return p;
      };
    }

    // En el editor de tema: abrir al seleccionar la sección
    var id = root.getAttribute('data-section-id');
    document.addEventListener('shopify:section:select', function (e) { if (e.detail.sectionId === id) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail.sectionId === id) close(); });
    window.BSCart = { open: open, close: close, refresh: refresh };
  }

  function boot() { document.querySelectorAll('.bsc').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function place() {
      var faq = document.querySelector('[data-bsfaq]');
      if (!faq) return;
      var wrap = faq.closest('.shopify-section') || faq;
      var reviews = document.querySelector('.bs-testimonios-v3');
      if (!reviews) return;
      var target = reviews.closest('.shopify-section') || reviews;
      if (target.previousElementSibling !== wrap) {
        target.parentNode.insertBefore(wrap, target);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', place);
    } else {
      place();
    }
    document.addEventListener('shopify:section:load', place);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
